module.exports = __webpack_public_path__ + "img/chevron-down.ab68eda6.svg";